import {
  buildReportWorkspaceModel,
  isReportNativeExportReady,
  isReportWorkspaceProject,
  reportNativeExportGateStatus,
  type ReportWorkspaceModel,
  type ReportWorkspaceStatus,
} from "@/features/report-workspace/report-workspace-model";
import type {
  AgentWorkspaceModelStatus,
  AgentWorkspaceReportBridge,
} from "./agent-workspace-model";

export const AGENT_WORKSPACE_REPORT_BRIDGE_SCHEMA_VERSION =
  "cogo.studio-agent-workspace-report-bridge.v1" as const;

export function reportWorkspaceStatusToAgentStatus(
  status: ReportWorkspaceStatus,
): AgentWorkspaceModelStatus {
  if (status === "ready") return "ready";
  if (status === "blocked") return "blocked";
  if (status === "missing") return "missing";
  return "warn";
}

export function buildAgentWorkspaceReportBridge(
  model: ReportWorkspaceModel,
): AgentWorkspaceReportBridge {
  const nativeExportReady = isReportNativeExportReady(model);
  return {
    schemaVersion: AGENT_WORKSPACE_REPORT_BRIDGE_SCHEMA_VERSION,
    status: reportWorkspaceStatusToAgentStatus(model.status),
    title: model.title,
    sourceKind: model.sourceKind,
    readyTargetCount: model.readyTargetCount,
    targetCount: model.targetCount,
    productionInputStatus: reportWorkspaceStatusToAgentStatus(
      model.productionInput.status,
    ),
    exportGateStatus: nativeExportReady
      ? "ready"
      : reportWorkspaceStatusToAgentStatus(reportNativeExportGateStatus(model)),
    nativeExportReady,
    formulaOracleStatus: reportWorkspaceStatusToAgentStatus(
      model.formulaOracle.status,
    ),
    chartSemanticStatus: reportWorkspaceStatusToAgentStatus(
      model.chartInspector.status,
    ),
    publishBlocked: model.publishBlocked,
    targets: model.targets.map((target) => ({
      format: target.format,
      status: reportWorkspaceStatusToAgentStatus(target.status),
      oracle: target.oracle,
    })),
    blockers: model.blockers,
    evidenceRefs: model.evidenceRefs,
  };
}

export function buildAgentWorkspaceReportBridgeFromProject(
  project: unknown,
): AgentWorkspaceReportBridge | null {
  if (!isReportWorkspaceProject(project)) return null;
  return buildAgentWorkspaceReportBridge(buildReportWorkspaceModel(project));
}
